import React, { useState } from "react";
import MetricInfoLogo from "../../ottoAnalytics/MetricInfoLogo";
import OttoMetricsInfo from "../../ottoAnalytics/OttoMetricsInfo";

/**
 * Self-contained info icon + drawer for sub-metric labels.
 * Encapsulates its own open/close state so the parent component does NOT re-render.
 */
export const SubMetricInfoIcon = ({ metricDetails }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <>
      <MetricInfoLogo onClick={() => setDrawerOpen(true)} />
      {drawerOpen && (
        <OttoMetricsInfo
          metricDetails={metricDetails}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        />
      )}
    </>
  );
};

const MetricHeader = ({
  title,
  metricDetails,
  children,
  className = "",
  titleElement: TitleElement = "span",
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className={`flex-row-centered justify-between ${className}`}>
      <span className="flex-row-centered gap-1">
        {typeof title === "string" ? (
          <TitleElement className="dashboard-title-label">{title}</TitleElement>
        ) : (
          title
        )}
        {metricDetails && <MetricInfoLogo onClick={() => setDrawerOpen(true)} />}
      </span>
      {children && <div className="flex-row-centered gap-1">{children}</div>}
      {drawerOpen && metricDetails && (
        <OttoMetricsInfo
          metricDetails={metricDetails}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        />
      )}
    </div>
  );
};

export default MetricHeader;
